import lottie from 'lottie-web';

const LOTTIE_SELECTOR = '.js-lottie-animation';
const LOTTIE_DATA_URL_ATTR = 'data-anim-url';

export const initLottie = () => {
	const animContainers = document.querySelectorAll(LOTTIE_SELECTOR);
	if (animContainers.length === 0) return;

	animContainers.forEach((container) => {
		const animUrl = container.getAttribute(LOTTIE_DATA_URL_ATTR);

		if (!animUrl) return;

		lottie.loadAnimation({
			container: container,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: animUrl,
		});
	});
};
